import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../theme';

export function SvgSupport(props) {
  const theme = useTheme();
  const { width = 24, height = 24, stroke = '#000' } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
      <defs>
        <filter id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g fillRule="evenodd" stroke={stroke} strokeLinejoin="round" strokeWidth="1">
        <g transform="translate(4 4)">
          <g>
            <g transform="matrix(-1 0 0 1 16 0)">
              <g strokeWidth="1.8" transform="translate(0 .5)" fill="none">
                <path d="M15.71 10.473c0 .964-.782 1.745-1.746 1.745H3.49L0 15.71V1.745C0 .781.781 0 1.745 0h12.219c.964 0 1.745.781 1.745 1.745v8.728z" />
              </g>
            </g>
          </g>
          <path
            stroke="none"
            fill={stroke}
            d="M8.417 7.8v-.17c0-.66.42-.97.84-1.37.37-.36.72-.8.72-1.53 0-1.07-.7-1.88-2.02-1.88-1.37 0-2.17.81-2.17 2.12h1.21c0-.56.36-.94.93-.94.55 0 .81.31.81.75 0 .36-.24.63-.54.92-.44.45-.99.89-.99 1.81v.29h1.21zm.09 2.2V8.61h-1.39V10h1.39z"
          />
        </g>
      </g>
    </svg>
  );
}

SvgSupport.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
